import PropTypes from 'prop-types';
import { useState } from 'react';
import ProductCarousel from '~/components/common/ProductCarousel';

const ProductTab = ({ productTab }) => {
	const productTabEntries = productTab.product_tab_entries.slice(0, 3);
	const [visibleTab, setVisibleTab] = useState(productTabEntries[0].id);

	const handleTabClick = (event, tab) => {
		setVisibleTab(tab);
		window.dispatchEvent(new Event('resize'));
	};

	const MobileSelect = () => {
		const handleSelectChange = event => {
			setVisibleTab(event.target.value);
			window.dispatchEvent(new Event('resize'));
		};

		return (
			<div className="mobile-tabs-header">
				<h2 className="mobile-header">{productTab.tl}</h2>
				<div className="productTabs-select">
					<select value={visibleTab} onChange={handleSelectChange}>
						{productTabEntries.map(item => (
							<option key={item.id} value={item.id}>
								{item.nm}
							</option>
						))}
					</select>
				</div>
			</div>
		);
	};

	if (!productTab) return null;
	return (
		<>
			<MobileSelect />

			<div className="tabs-header">
				{productTabEntries.map(item => (
					<button
						key={item.id}
						onClick={e => handleTabClick(e, item.id)}
						className={visibleTab == item.id ? 'tab-button tab-button1 active' : 'tab-button tab-button1'}>
						{item.nm}
					</button>
				))}
			</div>
			<div className="product-carousel-container">
				{productTabEntries.map(item => (
					<ProductCarousel key={item.id} productTabEntry={item} classActive={visibleTab == item.id ? 'embla active' : 'embla'} />
				))}
			</div>
		</>
	);
};

ProductTab.propTypes = {
	productTab: PropTypes.any
};

export default ProductTab;
